export default {
  comments: [],
  commentsCount: 0
}
